/** Chamilo (/scorm/) y runtime nativo (/scorm-content/). */
export function isNativeScormLink(link) {
  if (link == null || link === '') return false;
  return String(link).includes('/scorm-content/');
}

export function isLegacyChamiloScormLink(link) {
  if (link == null || link === '') return false;
  const s = String(link);
  if (s.includes('/scorm-content/')) return false;
  return s.includes('/scorm/') || s.includes('lp_controller.php');
}

export function isScormLaunchLink(link) {
  return isNativeScormLink(link) || isLegacyChamiloScormLink(link);
}

export function resolveScormUrl(link) {
  let newURL = link;
  if (link.includes('qualtia')) {
    newURL = link.split('/v3')[0] + link.split('/v3')[1];
  }
  if (newURL.split('undefined')[0] != undefined) {
    return newURL.split('undefined')[0];
  }
  return newURL;
}

/** URL de login Chamilo (index.php), no la del curso (lp_controller.php). */
export function resolveScormLoginUrl(link) {
  const courseUrl = resolveScormUrl(link);
  try {
    const parsed = new URL(courseUrl, window.location.origin);
    return parsed.origin + '/scorm/index.php';
  } catch (e) {
    return window.location.origin + '/scorm/index.php';
  }
}

export function launchScormIframe(containerSelector, { url, cveEmpleado, iframeHeight = '45em', onLoaded }) {
  const jq = window.jQuery || window.$;
  if (!jq) return;
  const courseUrl = resolveScormUrl(url);
  const loginUrl = resolveScormLoginUrl(url);
  const iframe = jq(
    '<form id="loginForm" target="myFrame" action="' + loginUrl + '" method="POST">' +
      '<input type="text" name="login" value="' + cveEmpleado + '" />' +
      '<input type="text" name="password" value="' + cveEmpleado + '" />' +
      '<input type="text" name="submitAuth" value="" />' +
      '<input type="text" name="_qf__formLogin" value="" />' +
      '<input type="submit">' +
      '</form>' +
      '<iframe id="iframeScorm" name="myFrame" src="#" style="width:100%; height:' + iframeHeight + ';"></iframe>'
  );
  jq(containerSelector).empty().append(iframe);
  const loginform = document.getElementById('loginForm');
  if (loginform) {
    loginform.style.display = 'none';
    loginform.submit();
  }
  const loginframe = document.getElementById('iframeScorm');
  if (loginframe) loginframe.style.display = 'none';

  const notifyLoaded = (() => {
    let done = false;
    return () => {
      if (done) return;
      done = true;
      if (typeof onLoaded === 'function') {
        onLoaded();
      }
    };
  })();

  setTimeout(() => {
    const iframeEl = document.createElement('iframe');
    iframeEl.name = 'myFrame';
    iframeEl.src = courseUrl;
    iframeEl.style.width = '100%';
    iframeEl.style.height = iframeHeight;
    iframeEl.addEventListener('load', notifyLoaded);
    // Si el iframe tarda o el evento load no dispara (red lenta / redirect), no dejar colgado el loader.
    setTimeout(notifyLoaded, 15000);
    jq(containerSelector).empty().append(iframeEl);
  }, 3000);
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/utils/scormIframeLauncher.js